import * as yup from 'yup'

export const schemaReset = yup.object().shape({
  email: yup.string().required('Enter an email').email('Enter a correct email'),
})
